import { styled } from '@mui/material/styles'

export const Notice = styled('aside')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(1.5, 2),
  boxSizing: 'border-box',
  width: '100%',
  borderRadius: 0,
  background: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  overflow: 'hidden'
}))

export const Content = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  color: theme.palette.common.white,
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))

export const Illustration = styled('img')({
  position: 'absolute',
  right: 0,
  top: -60,
  width: 160,
  pointerEvents: 'none'
})
